import * as state from './state.js';
import { showToast } from './dom.js';
import { getDoc } from './editor-view.js';

export function examplePathStem(path) {
    const basename = path.split('/').pop() || path;
    return basename.replace(/\.(ya?ml)$/i, '');
}

export function downloadOutputFilename(ext) {
    if (state.currentExamplePath) {
        const stem = examplePathStem(state.currentExamplePath);
        if (stem) {
            return `${stem}.${ext}`;
        }
    }

    const exampleParam = new URLSearchParams(window.location.search).get('example');
    if (exampleParam) {
        const stem = examplePathStem(exampleParam);
        if (stem) {
            return `${stem}.${ext}`;
        }
    }

    const yaml = getDoc(state.editor);
    const titleMatch = yaml.match(/^title:\s*(?:['"]([^'"]+)['"]|([^#\n]+))\s*$/m);
    if (titleMatch) {
        const title = (titleMatch[1] || titleMatch[2] || '').trim();
        const slug = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        if (slug) {
            return `${slug}.${ext}`;
        }
    }

    return `dashboard.${ext}`;
}

export function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}

export function initDownload() {
    const downloadBtn = document.getElementById('download-output-btn');
    if (!downloadBtn) return;

    downloadBtn.addEventListener('click', () => {
        const format = document.getElementById('format-selector').value;
        const previewContent = document.getElementById('preview-content');

        const formatInfo = {
            'svg': { ext: 'svg', mime: 'image/svg+xml' },
            'html': { ext: 'html', mime: 'text/html' },
            'png': { ext: 'png', mime: 'image/png' },
            'pdf': { ext: 'pdf', mime: 'application/pdf' },
            'terminal': { ext: 'txt', mime: 'text/plain' },
            'json': { ext: 'json', mime: 'application/json' },
            'text': { ext: 'txt', mime: 'text/plain' },
            'yaml': { ext: 'yml', mime: 'text/yaml' },
            'data': { ext: 'json', mime: 'application/json' },
        };

        const info = formatInfo[format] || { ext: 'txt', mime: 'text/plain' };
        let content;
        let blob = null;

        if (format === 'svg') {
            let svg = previewContent.querySelector('svg');
            if (!svg) {
                const iframe = previewContent.querySelector('#svg-preview-iframe');
                const iframeDoc = iframe && (iframe.contentDocument || iframe.contentWindow.document);
                svg = iframeDoc && iframeDoc.querySelector('svg');
            }
            if (svg) {
                content = new XMLSerializer().serializeToString(svg);
                blob = new Blob([content], { type: info.mime });
            }
        } else if (format === 'html') {
            const iframe = previewContent.querySelector('iframe');
            if (iframe && iframe.contentDocument) {
                content = iframe.contentDocument.documentElement.outerHTML;
                blob = new Blob([content], { type: info.mime });
            } else if (iframe && iframe.src) {
                fetch(iframe.src)
                    .then(res => res.text())
                    .then(html => {
                        const htmlBlob = new Blob([html], { type: info.mime });
                        downloadBlob(htmlBlob, downloadOutputFilename(info.ext));
                    });
                return;
            }
        } else if (format === 'png') {
            const img = previewContent.querySelector('img');
            if (img && img.src) {
                const a = document.createElement('a');
                a.href = img.src;
                a.download = downloadOutputFilename(info.ext);
                a.click();
                return;
            }
        } else if (format === 'terminal') {
            const pre = previewContent.querySelector('pre');
            if (pre) {
                content = pre.textContent;
                blob = new Blob([content], { type: info.mime });
            }
        } else if (state.CODE_FORMATS.has(format)) {
            content = getDoc(state.codePreview);
            if (content) {
                blob = new Blob([content], { type: info.mime });
            }
        }

        if (blob) {
            downloadBlob(blob, downloadOutputFilename(info.ext));
        } else {
            showToast('No content to download');
        }
    });
}
